import { injectService } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
import { useUserInfo } from '@/presentation/composables/user/use-user-info';
export function getUserDisplayCompanyName(user) {
    if (!user)
        return '';
    const { company_name, company_id } = user || {};
    const i18n = injectService(i18nSymbol);
    // 无公司 则属于个人账号
    if (!company_id) {
        return i18n.t('workspace.share.personalAccount');
    }
    // 公司跟当前用户一致，不显示Tag
    const { userInfo } = useUserInfo();
    if (company_id === userInfo.value.company_id) {
        return '';
    }
    return company_name;
}
